module.exports = __webpack_public_path__ + "static/media/29820026-p8U0wSgs.467fed99.JPG";